class TextAccordion {
	constructor(config) {
		this.config = Object.assign({
			scope: '.text_accordion'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		document.addEventListener('DOMContentLoaded', () => {
			const accordionParent = document.getElementById('accordionExample');
			if (!accordionParent) return;

			const accordionItems = Array.from(accordionParent.querySelectorAll('.text_accordion .row.position-relative.py-30.bottom-after'));
			if (accordionItems.length === 0) return;

			let currentlyOpenPanelId = null;
			let isProcessing = false;
			let scrollRequestId = null;
			let resizeRequestId = null;

			let lastProcessTime = 0;
			const THROTTLE_DELAY = 32;

			const itemCache = new Map();

			const cacheItemData = () => {
				itemCache.clear();
				accordionItems.forEach(item => {
					const trigger = item.querySelector('[data-bs-toggle="collapse"]');
					const panelId = trigger ? trigger.getAttribute('data-bs-target') : null;
					if (panelId) {
						const panelElement = document.querySelector(panelId);
						if (panelElement) {
							itemCache.set(item, {
								trigger,
								panelId,
								element: panelElement
							});
						}
					}
				});
			};

			const openPanel = (panelId) => {
				if (isProcessing || panelId === currentlyOpenPanelId) return;
				isProcessing = true;

				itemCache.forEach(({panelId: id, element}) => {
					if (id !== panelId && element?.classList.contains('show')) {
						const collapseInstance = bootstrap.Collapse.getOrCreateInstance(element, {toggle: false});
						collapseInstance.hide();
					}
				});

				setTimeout(() => {
					const targetData = Array.from(itemCache.values()).find(data => data.panelId === panelId);
					if (targetData?.element) {
						if (!targetData.element.classList.contains('show')) {
							const collapseInstance = bootstrap.Collapse.getOrCreateInstance(targetData.element, {toggle: false});
							targetData.element.addEventListener('shown.bs.collapse', () => {
								currentlyOpenPanelId = panelId;
								isProcessing = false;
							}, {once: true});
							collapseInstance.show();
						} else {
							currentlyOpenPanelId = panelId;
							isProcessing = false;
						}
					} else {
						isProcessing = false;
					}
				}, 100);
			};

			const findActiveItem = () => {
				const viewportHeight = window.innerHeight;
				const activationPoint = viewportHeight * 0.4;
				let bestCandidate = null;
				let bestScore = Infinity;

				for (const [item] of itemCache) {
					const rect = item.getBoundingClientRect();
					if (rect.bottom <= 0 || rect.top >= viewportHeight) continue;

					const itemCenter = rect.top + (rect.height * 0.5);
					const distanceToActivation = Math.abs(itemCenter - activationPoint);

					if (distanceToActivation < bestScore) {
						bestScore = distanceToActivation;
						bestCandidate = item;
					}
				}
				return bestCandidate;
			};

			const handleInteraction = () => {
				if (isProcessing) return;

				const now = performance.now();
				if (now - lastProcessTime < THROTTLE_DELAY) return;
				lastProcessTime = now;

				const activeItem = findActiveItem();
				if (activeItem) {
					const itemData = itemCache.get(activeItem);
					if (itemData?.panelId && itemData.panelId !== currentlyOpenPanelId) {
						openPanel(itemData.panelId);
					}
				}
			};

			const optimizedScrollHandler = () => {
				if (scrollRequestId) return;
				scrollRequestId = requestAnimationFrame(() => {
					handleInteraction();
					scrollRequestId = null;
				});
			};

			const optimizedResizeHandler = () => {
				if (resizeRequestId) return;
				resizeRequestId = requestAnimationFrame(() => {
					cacheItemData();
					lastProcessTime = 0;
					handleInteraction();
					resizeRequestId = null;
				});
			};

			window.addEventListener('scroll', optimizedScrollHandler, {passive: true});
			window.addEventListener('resize', optimizedResizeHandler);

			cacheItemData();

			setTimeout(() => {
				lastProcessTime = 0;
				handleInteraction();
			}, 100);

			window.addEventListener('beforeunload', () => {
				window.removeEventListener('scroll', optimizedScrollHandler);
				window.removeEventListener('resize', optimizedResizeHandler);
				if (scrollRequestId) cancelAnimationFrame(scrollRequestId);
				if (resizeRequestId) cancelAnimationFrame(resizeRequestId);
			});
		});
	}
}

export default new TextAccordion;
